import { List, ListItem, Typography, useTheme } from '@mui/material';
import DOMPurify from 'dompurify';

const additionalStyles = {
  ordered: { listStyle: 'decimal' },
  unordered: { listStyle: 'disc' },
  unorderedSmall: { listStyle: 'disc', ItemVariant: 'body2' },
};

const ContentList = props => {
  const theme = useTheme();
  return (
    <List sx={{ ...additionalStyles[props.variant], pl: 3 }}>
      {props.items.map((item, index) => (
        <ListItem sx={{ display: 'list-item', p: 0 }} key={index}>
          <Typography
            variant={additionalStyles[props.variant]?.ItemVariant ?? 'body1'}
            sx={{
              '& a': {
                color: theme.palette.primary.main,
              },
            }}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(item, {
                ALLOWED_ATTR: ['href', 'referrerpolicy', 'target'],
              }),
            }}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default ContentList;
